import { render, staticRenderFns } from "./PreferenceModal.vue?vue&type=template&id=81e4b6d2"
import script from "./PreferenceModal.vue?vue&type=script&lang=js"
export * from "./PreferenceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports